import {eventChannel, EventChannel} from 'redux-saga';

/**
 * Dispatch Custom Event on Window
 *
 * @param {string} name - event name
 * @param {*} detail - event details
 * @param {EventInit} options - event options, defults {cancelable: false, bubbles: false}
 */
export const dispatchCustomEvent = (
    name: string,
    detail: unknown = {},
    options: EventInit = {cancelable: false, bubbles: false},
) => {
    window.dispatchEvent(
        new CustomEvent(name, {
            bubbles: options.bubbles,
            cancelable: options.cancelable,
            detail,
        }),
    );
};

/**
 * Create event channel for help button
 * @param {string} eventName - event name
 * @return {Channel} Channel creator
 */
export const createEventChannel = (eventName: string): EventChannel<unknown> =>
    eventChannel(emitter => {
        const listener = (event: Event) => {
            emitter(event);
        };

        window.addEventListener(eventName, listener);
        return () => {
            window.removeEventListener(eventName, listener);
        };
    });
